export default __webpack_public_path__ + "static/media/UnitedC.950a3118.jpeg";